
import React from 'react';
import { Modal, Container, Row, Col } from 'react-bootstrap';
import { IMAGE_URL } from '../../services/api';
import ProtectedImage from '../../components/ProtectedImage';

const ProjectViewModal = ({ show, handleClose, selectedProject }) => {
    // const baseUrl = 'http://localhost:8000';  
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Project Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedProject && (
          <Container>
            <Row className="mb-2">
            <Col><strong>Title:</strong> {selectedProject.title}</Col>
            </Row>
            <Row className="mb-2">
            <Col> <strong> Descripation:</strong> {selectedProject.description} </Col>
            </Row>
            <Row className="mb-2">
            <Col> <strong> Start Date:</strong>{selectedProject.start_date}</Col>
            </Row>
            <Row className="mb-2">
             <Col><strong> End Date:</strong> {selectedProject.end_date} </Col>
            </Row>
            
            <Row className="mb-2">
            <Col><strong> Scope :</strong> {selectedProject.scope}</Col>
              
            </Row>
            <Row className="mb-2">
            <Col><strong> Budget:</strong> {selectedProject.project_budget} </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <strong>Status:</strong>{' '}
                <span style={{ color: selectedProject.is_active ? 'green' : 'red' }}>
                  {selectedProject.is_active ? 'Active' : 'Inactive'}
                </span>
              </Col>
            </Row>


            {selectedProject.attachments.map((url, index) => {
            const fullUrl = `${IMAGE_URL}${url}`; // Build the full URL
            const isPDF = fullUrl.toLowerCase().endsWith('.pdf');
            const isImage = /\.(jpg|jpeg|png|gif)$/i.test(fullUrl);

            return (
                <div key={index}>
                {isImage ? (
                    // <img
                    // src={fullUrl}
                    // alt={`Attachment ${index + 1}`}
                    // style={{
                    //     width: '100px',
                    //     height: '100px',
                    //     objectFit: 'cover',
                    //     borderRadius: '8px',
                    //     cursor: 'pointer',
                    // }}
                    // onClick={() => window.open(fullUrl, '_blank')}
                    // />
                    <ProtectedImage
  path={fullUrl}
  alt={`Attachment ${index + 1}`}
  style={{
    width: "100px",
    height: "100px",
    objectFit: "cover",
    borderRadius: "8px",
    cursor: "pointer",
  }}
  onClick={() => window.open(fullUrl, "_blank")}
/>

                ) : isPDF ? (
                    <p
                    style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => window.open(fullUrl, '_blank')}
                    >
                    View PDF {index + 1}
                    </p>
                ) : (
                    <a href={fullUrl} target="_blank" rel="noopener noreferrer">
                    Download File {index + 1}
                    </a>
                )}
                </div>
            );
            })}            
          </Container>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ProjectViewModal;
